import React, { useMemo, useState, useEffect } from "react";
import { Space, Table, Tag, Input } from "antd";
import "./index.css";
export default function Index(props) {
  const propData = props.data;
  const [filterText, setFilterText] = React.useState("");
  const [data, setData] = useState(propData);
  const [filteredData, setFilteredData] = useState(propData);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const filterData = (q) => {
    const filteredItems = data.filter(
      (item) =>
        JSON.stringify(item).toLowerCase().indexOf(q.toLowerCase()) !== -1
    );
    setFilteredData(filteredItems);
  };

  useEffect(() => {
    setData(props.data);
    setFilteredData(props.data);
  }, [props]);

  return (
    <div className="common-table font-poppins">
      {props.showFilter ? (
        <div>
          <Input
            placeholder={props.placeholder}
            style={{ width: "20%", minWidth: 200, float: "right", marginBottom: 10 }}
            className="h-9 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] focus:ring-2 focus:ring-[#B3D7FF] font-poppins"
            onChange={(v) => filterData(v.target.value)}
          />
        </div>
      ) : null}

      <Table
        columns={props.col}
        dataSource={filteredData}
        style={{ height: "50%", fontFamily: "Poppins" }}
        scroll={{ x: "100%" }}
        pagination={{
          pageSize: 7,
        }}
        className="font-sans"
        rowClassName={() => "no-hover"}
      />
    </div>
  );
}
